import * as React from 'react';
import { timeStamp, date, currency } from '~/lib/formatters';
import PageContentWrapper from '~/common/layout/PageContentWrapper';
import Table from '~/common/components/Table';
import StyledButton from '~/common/controls/StyledButton';


const TRANSACTION_TYPE_MAPPING = {
  'code': 'Payment',
  'payout': 'Payout',
  'deposit': 'Deposit',
};


export default (props) => {
  const { orgId, onClick, getOrganization, getLocation, showOrganization, showLocation, ...rest } = props;

  const handleOnClick = (e, model) => {
    e.preventDefault();
    onClick(model);
  }

  const columns: any = [
    {
      Header: 'Date',
      id: 'date',
      accessor: d => timeStamp(d.processDate),
    },
  ];

  // Do not show work date on sending side
  // TODO: Kind of hack, need to rethink
  if (!showOrganization) {
    columns.push({
      Header: 'Work Date',
      id: 'workDate',
      accessor: d => date(d.workDate),
    });
  }

  columns.push(...[
    {
      Header: 'Type',
      id: 'transactionType',
      accessor: d => TRANSACTION_TYPE_MAPPING[d.transactionType] || d.transactionType,
    },
    {
      Header: 'Amount',
      id: 'amount',
      accessor: (d) => {
        return d.toOrganizationId === orgId ? (
          <span style={{'color': 'green'}}>${currency(d.amount)}</span>
        ) : (
          <span style={{'color': 'red'}}>-${currency(d.amount)}</span>
        );
      },
    },
    {
      Header: 'Location',
      id: 'location',
      accessor: (d) => {
        const location = getLocation(d.locationId);
        return location && location.name;
      }
    },
    {
      Header: 'Site #',
      id: 'locationMap',
      accessor: (d) => {
        const l = getLocation(d.locationId);
        return l && l.locationMapping && l.locationMapping.map(m => m.siteId).join(', ');
      }
    },
  ]);

  if (showOrganization) {
    columns.push({
      Header: 'Recipient',
      id: 'toOrganization',
      accessor: (d) => {
        const org = getOrganization(d.toOrganizationId);
        return org && org.name;
      }
    });
    columns.push({
      Header: 'Note',
      accessor: 'note',
    });
  }

  columns.push({
    Cell: (row) => {
      if (row.original.receiptUrl) {
        return (
          <StyledButton
            onClick={(e) => handleOnClick(e, row.original)} label="Receipt" options={[]} />
        );
      }

      return null;
    }
  });

  return (
    <PageContentWrapper>
      <Table
        columns={columns}
        {...rest}
      />
    </PageContentWrapper>
  );
};
